import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LocationList from "../Components/Location";
import API from '../Services/PartyMenu'
import PartyMenuList from "../Components/PartyMenuList";

const PartyMenu = () => {
    const [locationId, setLocationId] = useState("")
    const [errors, setErrors] = useState({});
    const [logoPreview, setLogoPreview] = useState(null);
    const [image, setImage] = useState(null);


    const validateFields = () => {
        const errors = {};
        if (!locationId) { errors.locationId = "Center is required" }
        if (!image) errors.image = "Image is required";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const savePartyMenuData = async () => {
        const formData = new FormData();
        formData.append("location_id", locationId);
        formData.append("menu", image);
        try {
            const response = await API.savePartyMenu(formData);
            console.log("repsonse...", response)
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response.data?.message || "Unexpected response from the server.");
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data?.message || `Error: ${error.response.status}`);
                console.error("Server Error:", error.response);
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login")
            }
            else if (error.request) {
                toast.error("No response from the server. Please try again.");
                console.error("Network Error:", error.request);
            } else {
                toast.error("An unexpected error occurred.");
                console.error("Unexpected Error:", error.message);
            }
        }
    };
    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ['image/jpeg', 'application/pdf'];
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPEG and PDF formats are allowed.");
                event.target.value = '';
                return;
            }

            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.");
                event.target.value = '';
                return;
            }

            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        savePartyMenuData()
    };

    const handleCancel = () => {
        setImage("")
        setLocationId("")
    }

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Upload Menu</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <LocationList
                                            selectedLocation={locationId}
                                            label="Center"
                                            isRequired={false}
                                            setSelectedLocation={(location) => {
                                                setLocationId(location);
                                                if (location.trim()) {
                                                    setErrors((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.locationId;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                        {errors.locationId && <small className="text-danger" style={{ fontSize: "12px" }}>{errors.locationId}</small>}
                                    </div>
                                </div>
                                {/* <div className="row mt-3"> */}
                                <div className="col-md-4">
                                    <label>Upload Image <span className="text-danger">*</span></label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept=".jpeg, .jpg, application/pdf"
                                        onChange={handleLogoChange}
                                    />

                                    {/* <input
                                        type="file"
                                        className="form-control"
                                        accept="image/pdf, image/jpeg"
                                        onChange={handleLogoChange}
                                    /> */}
                                    {errors.image && <span className="text-danger">{errors.image}</span>}
                                </div>
                                <div className="col-md-4">
                                    {/* {logoPreview && (
                                        <img
                                            src={logoPreview || 'No Image Available'}
                                            alt="Preview"
                                            style={{ width: 100, height: 100, objectFit: "cover", marginTop: -15 }}
                                        />
                                    )} */}
                                    <div className="col-md-4">
                                        {logoPreview && (
                                            <div style={{ marginTop: -15 }}>
                                                {image?.type === "application/pdf" ? (
                                                    <iframe
                                                        src={logoPreview}
                                                        title="PDF Preview"
                                                        width="100%"
                                                        height="100"
                                                        style={{ border: "1px solid #ccc" }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={logoPreview}
                                                        alt="Preview"
                                                        style={{ width: 100, height: 100, objectFit: "cover" }}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                        <div className="mt-3">
                            <button
                                onClick={handleSubmit}
                                type="button"
                                className="btn btn-primary">
                                Submit
                            </button>
                            <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <PartyMenuList />
        </div>
    );
};

export default PartyMenu;

